var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"empty-box"},[_c('div',{staticClass:"empty-icon"},[_c('el-image',{attrs:{"src":"../../../static/image/empty.svg"}})],1),_vm._v(" "),_c('div',{staticClass:"empty-text"},[_vm._v("\n          "+_vm._s(_vm.emptyText)+"\n      ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b5a983a0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/childcomponents/Empty/index.vue
// module id = null
// module chunks = 